export default {"src":"https://static.spiritory.com/_next/static/media/authenticating.fe344344.svg","height":561,"width":664,"blurWidth":0,"blurHeight":0};